const actions = {
  GET_USERS_REQUEST: "GET_USERS_REQUEST",
  GET_USERS_SUCCESS: "GET_USERS_SUCCESS",
  GET_USERS_ERROR: "GET_ORGANIZATGET_USERS_ERRORIONS_ERROR",

  SEARCH_USERS: "SEARCH_USERS",
  SORT_USERS: "SORT_USERS",

  TOGGAL_EDIT_USER_MODAL: "TOGGAL_EDIT_USER_MODAL",

  DELETE_USER_REQUEST: "DELETE_USER_REQUEST",
  DELETE_USER_SUCCESS: "DELETE_USER_SUCCESS",

  UPDATE_USER: "UPDATE_USER",
  UPDATE_USER_REQUEST: "UPDATE_USER_REQUEST",
  UPDATE_USER_SUCCESS: "UPDATE_USER_SUCCESS",

  CHANGE_PASSWORD_REQUEST: "CHANGE_PASSWORD_REQUEST",
  CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",
  CHANGE_PASSWORD_ERROR: "CHANGE_PASSWORD_ERROR",

  GET_CODE_REQUEST: "GET_CODE_REQUEST",
  GET_CODE_SUCCESS: "CODE_SUCCESS",
  GET_CODE_ERROR: "CODE_ERROR",

  getCode: (email) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_CODE_REQUEST,
        email,
      });
    };
  },

  changePassword: (payload) => {
    return (dispatch) => {
      dispatch({
        type: actions.CHANGE_PASSWORD_REQUEST,
        payload,
      });
    };
  },

  getUsersRequest: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_USERS_REQUEST,
      });
    };
  },

  deleteUser: (user) => {
    return (dispatch, getState) => {
      dispatch({
        type: actions.DELETE_USER_REQUEST,
        user,
      });
    };
  },

  toggleEditModal: (user) => ({
    type: actions.TOGGAL_EDIT_USER_MODAL,
    user: user,
  }),

  updateUser: (user) => {
    return (dispatch) => {
      dispatch({
        type: actions.UPDATE_USER,
        user,
      });
    };
  },

  sortUsers: (users) => {
    return (dispatch) => {
      dispatch({
        type: actions.SORT_USERS,
        users,
      });
    };
  },

  searchUsers: (users) => {
    return (dispatch) => {
      dispatch({
        type: actions.SEARCH_USERS,
        users,
      });
    };
  },

  updateUserRequest: (user) => {
    return (dispatch, getState) => {
      const users = getState().users.users;
      const index = users.map((org) => org.id).indexOf(user.id);
      users[index] = user;

      dispatch({
        type: actions.UPDATE_USER_REQUEST,
        users,
        user,
      });
    };
  },
};

export default actions;
